import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const Footer = ({ className, values, page }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const landlordName = values?.manager
    ? `${values.manager.first_name || ''} ${values.manager.last_name || ''}`.trim()
    : '';
  const landlordInitials = landlordName
    ? landlordName
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase())
        .join('')
    : 'N/A';

  const tenantInitials =
    values?.tenants
      ?.filter((tenant) => tenant.signature && tenant.signature.trim() !== '')
      ?.map((tenant) =>
        tenant.name
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase())
          .join('')
      )
      ?.join(', ') || '';

  return (
    <Box
      className={className ? className : 'lease-form-footer'}
      position="relative"
      display="flex"
      justifyContent={isMobile ? 'space-between' : 'flex-end'}
      alignItems="center"
      sx={{ mb: 2, minHeight: 60, px: isMobile ? 2 : 0 }}
    >
      {/* Page Number */}
      <Box
        sx={{
          textAlign: isMobile ? 'left' : 'center',
          ...(isMobile
            ? {}
            : {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
              }),
        }}
      >
        <Typography variant="caption" fontSize="0.75rem">
          Page {page}
        </Typography>
      </Box>

      {/* Initials */}
      <Box display="flex" alignItems="center">
        <Box textAlign="center" mr={2}>
          <Typography variant="caption" fontSize="0.7rem">
            INITIALS
          </Typography>
        </Box>
        <Table
          size="small"
          sx={{ width: '120px', border: '1px solid', borderColor: 'grey.500' }}
        >
          <TableBody>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid',
                  borderColor: 'grey.500',
                  fontSize: '0.8rem',
                  p: 0.5,
                }}
              >
                Landlord
              </TableCell>
              <TableCell align="center" sx={{ fontSize: '0.8rem', p: 0.5 }}>
                Tenant(s)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid',
                  borderColor: 'grey.500',
                  fontSize: '0.9rem',
                  p: 0.5,
                }}
              >
                {landlordInitials}
              </TableCell>
              <TableCell align="center" sx={{ fontSize: '0.9rem', p: 0.5 }}>
                {tenantInitials}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export { Footer };
